<template>

<app-wrapper class="foot">

	<com-newsletter />

	<app-wrapper class="foot-content">

		<app-inner :row="!window.is.mobile">

			<com-links />

			<com-social />

		</app-inner>

		<app-inner :row="true" class="foot-content-text">

			<p>{{ settings.footer_text }}</p>

		</app-inner>

	</app-wrapper>

</app-wrapper>

</template>

<script>

import comNewsletter from './foot/Newsletter'
import comLinks from './foot/Links'
import comSocial from './foot/Social'

export default {

	components: {
		'com-newsletter': comNewsletter,
		'com-links': comLinks,
		'com-social': comSocial
	}

}

</script>

<style scoped>

.foot-content {
	background-color: var(--color-grey-dark);
	padding: 10px 0px 10px 0px;
}

.foot-content-text {
	padding: 20px 0px 10px 0px;
}

.is-mobile .foot-content-text {
    text-align: center;
}

.foot-content-text p {
	color: #fff;
	font-size: 10px;
	line-height: 14px;
}

</style>